/**
 * Non-component helpers shared by the labelled form controls (Input, Select,
 * Textarea). Kept in a separate module from {@link import('./formField')} so the
 * component file only exports components (fast-refresh friendly).
 */

/** Compose the `aria-describedby` value from the hint/error ids that are present. */
export function describedBy(
  hintId: string,
  errorId: string,
  hasHint: boolean,
  hasError: boolean,
): string | undefined {
  const ids = [hasHint ? hintId : null, hasError ? errorId : null].filter(Boolean);
  return ids.length > 0 ? ids.join(' ') : undefined;
}

/** Base control classes shared by inputs / selects / textareas, error-aware. */
export function controlClasses(hasError: boolean, extra = ''): string {
  return (
    'w-full rounded-md border bg-white px-3 py-2 text-sm text-slate-900 shadow-sm ' +
    'placeholder:text-slate-400 transition-colors ' +
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ' +
    'disabled:cursor-not-allowed disabled:opacity-60 ' +
    'dark:bg-navy-surface dark:text-slate-100 dark:placeholder:text-slate-500 ' +
    (hasError
      ? 'border-accent-500 focus-visible:outline-accent-500 dark:border-accent-500 '
      : 'border-slate-300 focus-visible:outline-brand-500 dark:border-navy-border ') +
    extra
  );
}
